export default {
  selectedValue: 'Q1',
  period: 'Quarterly',
  selectedYear: new Date().getFullYear(),
};
